import type { TemplateSlot } from "../utils/derive-template";
import { SchedulePeriodicSection } from "./SchedulePeriodicSection";

interface ScheduleDailySectionProps {
  readonly slots: readonly TemplateSlot[];
  readonly onEditSlot: (slot: TemplateSlot) => void;
  readonly onAddSlot?: () => void;
  readonly onContextMenu?: (slot: TemplateSlot, anchorRect: DOMRect) => void;
}

export function ScheduleDailySection(props: ScheduleDailySectionProps) {
  return <SchedulePeriodicSection title="Quotidien" {...props} />;
}
